<ng-container *transloco="let t">
  <div class="flex min-w-0 flex-1 flex-col">
    <span class="truncate text-sm">{{ child().label }}</span>
    @if (remainingLabel(); as label) {
      <span class="text-xs text-text-tertiary" data-testid="remaining-time">{{ label }}</span>
    }
  </div>

  <ng-template #deleteButton>
    <button
      appearance="flat"
      iconStart="@tui.trash-2"
      size="s"
      tuiIconButton
      type="button"
      [attr.aria-label]="t('Supprimer')"
      [tuiHint]="t('Supprimer')"
      (click)="delete.emit()"></button>
  </ng-template>

  @switch (child().state.status) {
    @case (ActionStatus.WAITING) {
      <div class="flex items-center gap-1">
        <pxc-sync-progress-chip variant="flat" />
        <ng-container [ngTemplateOutlet]="deleteButton" />
      </div>
    }
    @case (ActionStatus.SUCCESS) {
      <tui-icon class="text-foreground-success-primary" icon="@tui.check" />
    }
    @case (ActionStatus.IN_PROGRESS) {
      <div class="flex items-center gap-1">
        <span class="text-sm font-medium text-text-secondary">{{ percentage() }}%</span>
        <ng-container [ngTemplateOutlet]="deleteButton" />
      </div>
    }
    @case (ActionStatus.ERROR) {
      <div class="flex items-center gap-1">
        <span class="text-sm font-medium text-foreground-error-primary">{{ t('Erreur') }}</span>
        <button
          appearance="flat"
          iconStart="@tui.refresh-cw"
          size="s"
          tuiIconButton
          type="button"
          [attr.aria-label]="t('Réessayer')"
          [tuiHint]="t('Réessayer')"
          (click)="retry.emit()"></button>
        <ng-container [ngTemplateOutlet]="deleteButton" />
      </div>
    }
    @case (ActionStatus.INTERRUPTION) {
      <div class="flex items-center gap-1">
        <button appearance="outline" size="s" tuiButton type="button" (click)="resume.emit()">
          {{ t('Reprendre') }}
        </button>
        <ng-container [ngTemplateOutlet]="deleteButton" />
      </div>
    }
  }
</ng-container>
